/** Public SSR and hydration delegate ownership to the shared legacy policy. */
import { legacyCanonicalUrl } from "./canonical-origin";
import type { CanonicalPage } from "./public-canonical-contract";
export type { CanonicalPage } from "./public-canonical-contract";
export const canonicalIntegrationStatus = "integrated" as const;
export function canonicalFor(page: CanonicalPage): string {
  if (!/^https?:\/\//.test(page.currentCanonical)) throw new Error("Absolute current canonical required");
  return legacyCanonicalUrl(page.pathname, page.currentCanonical, {
    currentCar: page.kind === "car" ? page.evidence as Record<string, unknown> : undefined,
  });
}
